import React from "react"

interface LoaderProps {
  size?: "small" | "large"
  color?: string // Tailwind color class e.g., "blue-500"
}

const LoaderComponent: React.FC<LoaderProps> = ({
  size = "small",
  color = "blue-500",
}) => {
  const sizeClasses = size === "small" ? "w-4 h-4 border-2" : "w-8 h-8 border-4"

  const borderColor = `border-gray-200 border-t-blue-500`

  return (
    <div className="flex justify-center items-center">
      <div
        className={`${sizeClasses} ${borderColor} rounded-full animate-spin`}
      ></div>
    </div>
  )
}

export default LoaderComponent
